const S3_HOST = "https://s3.kz-1.srvstorage.kz";

export function proxyS3Url(url: string): string {
  if (url.startsWith(S3_HOST)) {
    return url.replace(S3_HOST, "/s3-proxy");
  }
  return url;
}
